export const adjustButtonSx = {
  width: { xs: 60, md: 80, lg: 90 },
  height: { xs: 70, md: 90, lg: 100 },
  bgcolor: "grey.200",
  borderRadius: 2,
  "&:hover": { bgcolor: "grey.300" },
  "& .MuiSvgIcon-root": {
    fontSize: { xs: 32, md: 40, lg: 48 },
  },
};
